// 재랜더는 필요없으므로 그냥 값 할당

export const refDetailTimes: Record<string, { refServerTimestamp: string; refClientTimestamp: string }> = {};

export const refPositionTimes: Record<string, { refServerTimestamp: string; refClientTimestamp: string }> = {};
